import { render, staticRenderFns } from "./chaterxbkbot.vue?vue&type=template&id=65b5932c&scoped=true"
import script from "./chaterxbkbot.vue?vue&type=script&lang=js"
export * from "./chaterxbkbot.vue?vue&type=script&lang=js"
import style0 from "./chaterxbkbot.vue?vue&type=style&index=0&id=65b5932c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5932c",
  null
  
)

export default component.exports